import { DollarSignCircleIcon, PencilIcon } from '@grupoboticario/flora-react-icons';
import { ButtonIcon, Card } from 'ui/components/primitives';
import { Payment } from './Summary.components.styles';
import { SUMMARY_COMPONENTS_CONST } from './Summary.components.d';
import type { PaymentProps } from './Summary.components.d';

const PaymentBase = ({ changePaymentMethod, description = '' }: PaymentProps) => (
  <Payment.Component data-testid={SUMMARY_COMPONENTS_CONST.PAYMENT_TEST_ID}>
    <Payment.Title>
      <DollarSignCircleIcon size={24} />
      Forma de pagamento
    </Payment.Title>

    <Card radius="rounded">
      <Payment.Row>
        <Payment.Text tabIndex={0} aria-label={description}>
          {description}
        </Payment.Text>

        <ButtonIcon
          onClick={changePaymentMethod}
          size="small"
          tabIndex={0}
          aria-label="Editar forma de pagamento"
        >
          <PencilIcon size={24} />
        </ButtonIcon>
      </Payment.Row>
    </Card>
  </Payment.Component>
);

export default PaymentBase;
